module.exports = __webpack_public_path__ + "static/vu_pham-8e3b066dfae8051631870a25e8b4196b.png";